/**
 * Do not edit directly
 * Generated on Tue, 23 Jul 2024 13:51:28 GMT
 */

module.exports = {green : {100:{
            name: "green.100",
            hex: "#FAFFFC",
            
          },200:{
            name: "green.200",
            hex: "#EBF2EF",
            
          },300:{
            name: "green.300",
            hex: "#D1E0D9",
            
          },400:{
            name: "green.400",
            hex: "#B6CFC2",
            
          },500:{
            name: "green.500",
            hex: "#86B09B",
            
          },600:{
            name: "green.600",
            hex: "#307553",
            
          },700:{
            name: "green.700",
            hex: "#275E43",
            
          },800:{
            name: "green.800",
            hex: "#244C38",
            
          }},
blue : {100:{
            name: "blue.100",
            hex: "#F5FAFF",
            
          },200:{
            name: "blue.200",
            hex: "#E6F1FC",
            
          },300:{
            name: "blue.300",
            hex: "#C0D8F0",
            
          },400:{
            name: "blue.400",
            hex: "#88B1D9",
            
          },500:{
            name: "blue.500",
            hex: "#5D96CF",
            
          },600:{
            name: "blue.600",
            hex: "#3971A8",
            
          },700:{
            name: "blue.700",
            hex: "#21588F",
            
          },800:{
            name: "blue.800",
            hex: "#194673",
            
          }},
red : {100:{
            name: "red.100",
            hex: "#FFF7F9",
            
          },200:{
            name: "red.200",
            hex: "#FEEEF2",
            
          },300:{
            name: "red.300",
            hex: "#F0C4CD",
            
          },400:{
            name: "red.400",
            hex: "#E296A6",
            
          },500:{
            name: "red.500",
            hex: "#C6516A",
            
          },600:{
            name: "red.600",
            hex: "#AF2645",
            
          },700:{
            name: "red.700",
            hex: "#980B29",
            
          },800:{
            name: "red.800",
            hex: "#800D25",
            
          }},
purple : {100:{
            name: "purple.100",
            hex: "#FCFAFF",
            
          },200:{
            name: "purple.200",
            hex: "#F2ECFE",
            
          },300:{
            name: "purple.300",
            hex: "#D7CEE9",
            
          },400:{
            name: "purple.400",
            hex: "#B9ABD5",
            
          },500:{
            name: "purple.500",
            hex: "#8471AB",
            
          },600:{
            name: "purple.600",
            hex: "#533E7D",
            
          },700:{
            name: "purple.700",
            hex: "#3B2566",
            
          },800:{
            name: "purple.800",
            hex: "#2A174F",
            
          }},
orange : {100:{
            name: "orange.100",
            hex: "#FFFAF5",
            
          },200:{
            name: "orange.200",
            hex: "#FFF3E8",
            
          },300:{
            name: "orange.300",
            hex: "#F3D8C0",
            
          },400:{
            name: "orange.400",
            hex: "#E7B88F",
            
          },500:{
            name: "orange.500",
            hex: "#CF8545",
            
          },600:{
            name: "orange.600",
            hex: "#B4631D",
            
          },700:{
            name: "orange.700",
            hex: "#8E4D14",
            
          },800:{
            name: "orange.800",
            hex: "#784213",
            
          }},
grey : {100:{
            name: "grey.100",
            hex: "#FCFEFF",
            
          },200:{
            name: "grey.200",
            hex: "#F5F7FA",
            
          },300:{
            name: "grey.300",
            hex: "#E6EDF5",
            
          },400:{
            name: "grey.400",
            hex: "#C8D3E0",
            
          },410:{
            name: "grey.410",
            hex: "#B8C6D6",
            
          },500:{
            name: "grey.500",
            hex: "#596D84",
            
          },600:{
            name: "grey.600",
            hex: "#475A70",
            
          },700:{
            name: "grey.700",
            hex: "#36485C",
            
          },800:{
            name: "grey.800",
            hex: "#2E3A47",
            
          },900:{
            name: "grey.900",
            hex: "#212933",
            
          }},
shades : {white:{
            name: "shades.white",
            hex: "#FFFFFF",
            
          },black:{
            name: "shades.black",
            hex: "#000000",
            
          },transparent:{
            name: "shades.transparent",
            hex: "transparent",
            
          }},
yellow : {100:{
            name: "yellow.100",
            hex: "#faf8f2",
            
          },200:{
            name: "yellow.200",
            hex: "#fcf3dd",
            
          },300:{
            name: "yellow.300",
            hex: "#fce7b1",
            
          },400:{
            name: "yellow.400",
            hex: "#fcd97e",
            
          },500:{
            name: "yellow.500",
            hex: "#fccb4c",
            
          },600:{
            name: "yellow.600",
            hex: "#ffc121",
            
          },700:{
            name: "yellow.700",
            hex: "#f7b200",
            
          },800:{
            name: "yellow.800",
            hex: "#e5a500",
            
          }},
brown : {200:{
            name: "brown.200",
            hex: "#F6F1E5",
            
          },300:{
            name: "brown.300",
            hex: "#E4D9C2",
            
          },400:{
            name: "brown.400",
            hex: "#DACCAA",
            
          },700:{
            name: "brown.700",
            hex: "#5E4D27",
            
          },800:{
            name: "brown.800",
            hex: "#3E3114",
            
          }},
smart : {400:{
            name: "smart.400",
            hex: "#7495B9",
            
          },500:{
            name: "smart.500",
            hex: "#4D7199",
            
          },600:{
            name: "smart.600",
            hex: "#2E5988",
            
          },700:{
            name: "smart.700",
            hex: "#264A6E",
            
          }},};